import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { PaginatedResponse } from '../../interfaces/PaginatedResponse';
import { Refund } from '../../interfaces/Refund/Refund';
import { RefundFilter } from '../../interfaces/Refund/RefundFilter';
import { getRefunds } from '../../api/Refund';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { SearchBox } from '../../components/SearchBox/SearchBox';
import { RefundsTable } from './RefundsTable';

export const RefundsPage = () => {
  const [refunds, setRefunds] = useState<PaginatedResponse<Refund>>({
    data: [],
    totalCount: 0,
  });
  const [filter, setFilter] = useState<RefundFilter>({
    email: '',
    pagination: {
      page: 0,
      pageSize: 10,
    },
  });
  const [loading, setLoading] = useState(false);

  const refreshRefunds = () => {
    setLoading(true);
    getRefunds(filter)
      .then((r) => setRefunds(r))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshRefunds();
  }, [filter]);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Waiting open={loading} />

      <Box sx={{ display: 'flex', flexDirection: 'row', mb: 1.5 }}>
        <Typography variant='h5'>İade Talepleri</Typography>
        <Box sx={{ flexGrow: 1 }} />
        <SearchBox
          placeholder='E-Posta Adresi'
          initialValue={filter.email ?? ''}
          onChange={(s) =>
            setFilter({
              ...filter,
              email: s,
              pagination: { ...filter.pagination, page: 0 },
            })
          }
        />
      </Box>

      <RefundsTable
        refunds={refunds.data}
        totalCount={refunds.totalCount}
        pagination={filter.pagination}
        onPagination={(p) => setFilter({ ...filter, pagination: p })}
      />
    </Box>
  );
};
